/* import __COLOCATED_TEMPLATE__ from './channel-uploads-step.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class RequestStepsChannelUploadsStep extends Component {}
